<template>
  <div v-loading="isLoading">
    <div class="tw-flex tw-justify-between tw-items-center tw-mb-10">
      <div class="tw-flex tw-justify-between tw-items-center tw-gap-2">
        <i-button
          v-if="$isInRole(['ADMIN', 'CONSULTANT']) || (($isInRole(['HR']) && me.features.case_assessments))"
          type="primary"
          size="medium"
          @click="isAddForeignerDialogOpen = true"
        >
          <icon-user-add class="tw-mr-2" />
          {{ $t('foreigners.new_foreigner') }}
        </i-button>
        <i-button
          v-if="$isInRole(['ADMIN', 'CONSULTANT', 'HR', 'AGENCY'])"
          type="primary"
          size="medium"
          :is-loading="isExporting"
          @click="exportForeigners"
        >
          <icon-upload class="tw-mr-2" />
          {{ $t('foreigners.export_button') }}
        </i-button>
      </div>
      <div>
        <DebouncedSearch
          :query="searchQuery"
          :search="search"
          :placeholder="$t('common.actions.search')"
        />
      </div>
    </div>

    <div>
      <ForeignerFilters class="tw-mb-10" />
      <div class="tw-overflow-auto">
        <ForeignersList />
      </div>
      <ForeignersListPagination />
    </div>

    <AddForeignerDialog
      :is-open="isAddForeignerDialogOpen"
      @close="isAddForeignerDialogOpen = false"
      @refresh="load"
    />
    <ForeignersMessagingPopover />
  </div>
</template>

<script>
import ForeignerFilters from '@/components/Foreigners/ForeignersFilters.vue';
import ForeignersList from '@/components/Foreigners/List/ForeignersList.vue';
import AddForeignerDialog from '@/components/Dialogs/AddForeignerDialog.vue';
import helpers from '@/helpers';
import ForeignersListPagination from '@/components/Foreigners/List/ForeignersListPagination.vue';
import ForeignersMessagingPopover from '@/components/Foreigners/Messaging/ForeignersMessagingPopover.vue';
import DebouncedSearch from '@/components/shared/DebouncedSearch.vue';
import { mapState } from 'vuex';

export default {
  components: {
    DebouncedSearch,
    ForeignersMessagingPopover,
    ForeignersListPagination,
    ForeignerFilters,
    ForeignersList,
    AddForeignerDialog,
  },
  data() {
    return {
      searchQuery: '',
      isExporting: false,
      isAddForeignerDialogOpen: false,
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.v2.shared.profile.me,
      filters: (state) => state.v2.admin.foreigners.foreigners.filters,
      isLoading: (state) => state.v2.admin.foreigners.foreigners.isLoading,
    }),
  },
  watch: {
    filters: {
      handler() {
        this.load();
      },
      deep: true,
      immediate: true,
    },
  },
  async mounted() {
    this.$store.dispatch('v2/admin/cms/clients/companies/loadAllCompanies');
    this.$store.dispatch('v2/admin/cms/internal/users/loadAllUsers');
    this.$store.dispatch('v2/admin/cms/permitManagement/statuses/loadAllStatuses');

    this.searchQuery = this.filters.search; // TODO: verify this is working
  },
  methods: {
    load() {
      this.$store.dispatch('v2/admin/foreigners/foreigners/loadForeigners');
    },

    search(query) {
      this.$store.commit('v2/admin/foreigners/foreigners/updateFilter', { field: 'search', payload: query });
    },

    async exportForeigners() {
      this.isExporting = true;

      const response = await this.$store.dispatch('v2/admin/foreigners/foreigners/exportForeigners');
      helpers.downloadFromBlob(response, 'itrack_foreigners_export.xlsx');

      this.isExporting = false;
    },
  },
};
</script>
